import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class ModalService {
    modalChanged: any = new Subject<any>();
    modalButtonClicked: any = new Subject<any>();

    constructor() {

    }

    showLoadingModal(value: string, showStopTest: boolean = true, showOkButton: boolean = false){
        this.modalChanged.next({
            'showLoading': true,
            'value': value,
            'showStopTest': showStopTest,
            'showOkButton': showOkButton
        });
    }

    hideLoadingModal(){
        this.modalChanged.next({
            'showLoading': false
        });
    }

    stopTest() {
        this.modalButtonClicked.next({
            'stopTest' : true
        });
    }

    okClicked() {
        this.modalButtonClicked.next({
            'closeDialog' : true
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/modals/modal.service.ts